import { Divider, Paper } from "@mui/material";
import UndoRedo from "features/WorklistTools/shared/components/UndoRedo";
import { WorklistTools } from "features/WorklistTools/shared/interfaces";
import React from "react";
import { GeneralOptions } from "./GeneralOptions";
import { SelectionView } from "./SelectionView";

export const ThawToolbar = () => {
  return (
    <React.Fragment>
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          flexWrap: "wrap",
          marginLeft: "20px",
        }}
      >
        <GeneralOptions />
        <UndoRedo method={WorklistTools.Thaw} />
        <Divider flexItem orientation="vertical" sx={{ mx: 0.5, my: 1 }} />
        <SelectionView />
      </Paper>
    </React.Fragment>
  );
};
